import React, { useState, useEffect, useMemo } from 'react';
import { UpdateIstQuarter, getI_stQuarterDetails } from '../../Api';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Card,
    Header,
    Eyebrow,
    Title,
    Subtitle,
    SectionLabel,
    GradeGrid,
    GradeField,
    GradeLabel,
    Input,
    CalendarWrap,
    CalendarToolbar,
    ToolbarButton,
    MonthTitle,
    CalendarGrid,
    WeekdayCell,
    DayCell,
    DayNumber,
    EmptyCell,
    //Hint,
    LegendRow,
    LegendItem,
    LegendSwatch,
    StatsBar,
    StatBlock,
    StatValue,
    StatLabel,
    Btt01,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold,
    ErrorMessage
} from './style';
import LoadingSpinner from '../../components/Loading';
import ResponsivePickers from '../../components/Datebimestre';
import { SeletorMarcacao, LegendaNaoLetivos, mapaNaoLetivos, contarNaoLetivos, estiloMarcacao, tituloDoDia, TIPOS_DIA } from '../../components/NonSchoolDays';

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
const MONTH_NAMES = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

// Chave YYYY-MM-DD de uma data SALVA/com timestamp, lida em UTC.
// Datas no banco costumam vir como meia-noite UTC (ex.: 2025-02-10T00:00:00.000Z);
// ler em horário local (UTC-3 no Brasil) recuaria um dia e não casaria com a
// célula do calendário. Em UTC, o dia bate exatamente.
const toKey = (value) => {
    const dt = new Date(value);
    if (isNaN(dt.getTime())) return null;
    return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
};

const keyFromParts = (y, m0, d) =>
    `${y}-${String(m0 + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

const EditProfile = () => {
    const navigate = useNavigate();
    const [assessmentFormat, setassessmentFormat] = useState('');
    const [/*assessmentRegime*/, setAssessmentRegime] = useState('');
    const [regime, setRegime] = useState('');
    const [id_IstQuarter, setid_IstQuarter] = useState({});
    const [startday, setStartday] = useState('');
    const [startmonth, setStartmonth] = useState('');
    const [startyear, setStartyear] = useState('');
    const [endday, setEndday] = useState('');
    const [endmonth, setEndmonth] = useState('');
    const [endyear, setEndyear] = useState('');
    const [startSelectedDate, setStartSelectedDate] = useState('');
    const [endSelectedDate, setEndSelectedDate] = useState('');
    const [totalGrade, setTotalGrade] = useState('');
    const [averageGrade, setAverageGrade] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // schoolDays: array de { date, isSchoolDay } — MESMA estrutura da tela original
    const [schoolDays, setSchoolDays] = useState([]);
    const [viewDate, setViewDate] = useState(new Date());
    // feriados, recessos e outros dias sem aula: [{ date, type, description }]
    const [nonSchoolDays, setNonSchoolDays] = useState([]);
    const [markMode, setMarkMode] = useState('letivo');
    const [markDesc, setMarkDesc] = useState('');
    const nonMap = useMemo(() => mapaNaoLetivos(nonSchoolDays), [nonSchoolDays]);
    const contagem = useMemo(() => contarNaoLetivos(nonSchoolDays), [nonSchoolDays]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const $assessmentFormat = sessionStorage.getItem('assessmentFormat');
            setassessmentFormat($assessmentFormat);
            setAssessmentRegime(sessionStorage.getItem('assessmentRegime'));

            const idIstQuarter = sessionStorage.getItem('IstQuarterInformation');
            const res = await getI_stQuarterDetails(idIstQuarter);

            setRegime(res.data.assessmentRegime);

            // Igual à tela original: tudo que veio do banco é dia letivo (isSchoolDay: true)
            const formattedSchoolDays = (res.data.schoolDays || []).map(day => ({
                _id: day._id,
                date: day.date,
                isSchoolDay: true
            }));
            setSchoolDays(formattedSchoolDays);
            setNonSchoolDays((res.data.nonSchoolDays || []).map(d => ({
                date: d.date,
                type: d.type,
                description: d.description || ''
            })));

            setid_IstQuarter(res.data._id);
            setStartday(res.data.startday || '');
            setStartmonth(res.data.startmonth || '');
            setStartyear(res.data.startyear || '');
            setEndday(res.data.endday || '');
            setEndmonth(res.data.endmonth || '');
            setEndyear(res.data.endyear || '');
            setTotalGrade(res.data.totalGrade || '');
            setAverageGrade(res.data.averageGrade || '');

            // Pré-preenche as datas dos pickers, se houver período salvo
            if (res.data.startday && res.data.startmonth && res.data.startyear) {
                setStartSelectedDate(
                    new Date(res.data.startyear, res.data.startmonth - 1, res.data.startday)
                );
                setViewDate(new Date(res.data.startyear, res.data.startmonth - 1, 1));
            } else if (formattedSchoolDays.length > 0) {
                setViewDate(new Date(formattedSchoolDays[0].date));
            }
            if (res.data.endday && res.data.endmonth && res.data.endyear) {
                setEndSelectedDate(
                    new Date(res.data.endyear, res.data.endmonth - 1, res.data.endday)
                );
            }

            setLoading(false);
        })();
    }, []);

    // Mapa: chave do dia -> isSchoolDay (para achar rápido no calendário)
    const dayMap = useMemo(() => {
        const map = new Map();
        schoolDays.forEach(d => {
            const k = toKey(d.date);
            if (k) map.set(k, d.isSchoolDay);
        });
        return map;
    }, [schoolDays]);

    // Limites do período como chaves (ou null)
    const startKey = useMemo(() => {
        if (!startday || !startmonth || !startyear) return null;
        return keyFromParts(Number(startyear), Number(startmonth) - 1, Number(startday));
    }, [startday, startmonth, startyear]);

    const endKey = useMemo(() => {
        if (!endday || !endmonth || !endyear) return null;
        return keyFromParts(Number(endyear), Number(endmonth) - 1, Number(endday));
    }, [endday, endmonth, endyear]);

    const hasPeriod = startKey && endKey && endKey >= startKey;

    // Ajusta a visão do calendário quando o início muda
    useEffect(() => {
        if (startKey) {
            const [y, m] = startKey.split('-').map(Number);
            setViewDate(new Date(y, m - 1, 1));
        }
    }, [startKey]);

    // Alterna um dia: se já existe no array, inverte isSchoolDay; senão adiciona como letivo
    const toggleDay = (year, month0, day) => {
        const targetKey = keyFromParts(year, month0, day);
        setSchoolDays(prev => {
            const exists = prev.some(d => toKey(d.date) === targetKey);
            if (exists) {
                return prev.map(d =>
                    toKey(d.date) === targetKey
                        ? { ...d, isSchoolDay: !d.isSchoolDay }
                        : d
                );
            }
            // cria como letivo, em meia-noite UTC (consistente com a leitura UTC)
            return [...prev, { date: new Date(Date.UTC(year, month0, day)).toISOString(), isSchoolDay: true }];
        });
    };

    // Clique no dia conforme o modo escolhido (letivo / feriado / recesso / outro)
    const handleDayClick = (y_, m0_, d_) => {
      const key = keyFromParts(y_, m0_, d_);
      if (markMode === 'letivo') {
        setNonSchoolDays(prev => prev.filter(n => toKey(n.date) !== key));
        toggleDay(y_, m0_, d_);
        return;
      }
      const atual = nonMap.get(key);
      setNonSchoolDays(prev => {
        const sem = prev.filter(n => toKey(n.date) !== key);
        if (atual && atual.type === markMode) return sem; // mesmo tipo: desmarca
        return [...sem, { date: new Date(Date.UTC(y_, m0_, d_)).toISOString(), type: markMode, description: markDesc.trim() }];
      });
      // dia marcado como feriado/recesso/outro deixa de ser letivo
      setSchoolDays(prev => prev.map(d => (toKey(d.date) === key ? { ...d, isSchoolDay: false } : d)));
    };

    // Grade do mês em exibição
    const calendarCells = useMemo(() => {
        const year = viewDate.getFullYear();
        const month = viewDate.getMonth();
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const cells = [];
        for (let i = 0; i < firstDay; i++) cells.push(null);
        for (let d = 1; d <= daysInMonth; d++) {
            const key = keyFromParts(year, month, d);
            const weekday = new Date(year, month, d).getDay();
            const weekend = weekday === 0 || weekday === 6;
            const isLetivo = dayMap.get(key) === true;
            const inRange = !hasPeriod || (key >= startKey && key <= endKey);
            cells.push({ day: d, year, month0: month, key, isLetivo, weekend, inRange });
        }
        return cells;
    }, [viewDate, dayMap, hasPeriod, startKey, endKey]);

    const goPrevMonth = () =>
        setViewDate(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
    const goNextMonth = () =>
        setViewDate(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));

    const totalLetivos = useMemo(
        () => schoolDays.filter(d => d.isSchoolDay).length,
        [schoolDays]
    );

    const handleSubmit = async () => {
        if (assessmentFormat === 'grade' && (!totalGrade || !averageGrade)) {
            setErrorMessage('Preencha todos os campos de nota antes de continuar.');
            return;
        }

        // Igual à tela original: envia só os dias marcados como letivos
        const selectedSchoolDays = schoolDays
            .filter(day => day.isSchoolDay)
            .map(day => ({ date: day.date }));

        if (selectedSchoolDays.length === 0) {
            setErrorMessage('Selecione ao menos um dia letivo no calendário.');
            return;
        }

        // só os feriados/recessos/outros dentro do período
        const nonSchoolDaysPayload = nonSchoolDays
          .filter(n => { const k = toKey(n.date); return !hasPeriod || (k >= startKey && k <= endKey); })
          .map(n => ({ date: n.date, type: n.type, description: n.description || '' }));

        setLoading(true);

        const payload = {
            startday,
            startmonth,
            startyear,
            endday,
            endmonth,
            endyear,
            totalGrade,
            averageGrade,
            schoolDays: selectedSchoolDays,
            nonSchoolDays: nonSchoolDaysPayload
        };

        try {
            const res = await UpdateIstQuarter(id_IstQuarter, payload);
            if (res) {
                alert('Bimestre atualizado com sucesso!');
                navigate(-1);
            } else {
                setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
            }
        } catch (error) {
            setErrorMessage('Ocorreu um erro inesperado. Tente novamente mais tarde.');
        } finally {
            setLoading(false);
        }
    };

    const handleGoBack = () => navigate(-1);

    const periodoLabel = regime === 'TRIMESTRAL' ? 'Trimestre' : 'Bimestre';

    return (
        <Container>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <Card>
                    <Header>
                        <Eyebrow>Configuração de período</Eyebrow>
                        <Title>Edição do 1º {periodoLabel}</Title>
                        <Subtitle>
                            Defina o período e toque nos dias letivos no calendário.
                        </Subtitle>
                    </Header>

                    <SectionLabel>Período do {periodoLabel.toLowerCase()}</SectionLabel>
                    <ResponsivePickers
                        schoolYear={startyear}
                        selectedDateStart={startSelectedDate}
                        selectedDateEnd={endSelectedDate}
                        setSelectedDateStart={setStartSelectedDate}
                        setDayStart={setStartday}
                        setMonthStart={setStartmonth}
                        setYearStart={setStartyear}
                        setSelectedDateEnd={setEndSelectedDate}
                        setDayEnd={setEndday}
                        setMonthEnd={setEndmonth}
                        setYearEnd={setEndyear}
                    />

                    {assessmentFormat === 'grade' && (
                        <>
                            <SectionLabel>Notas</SectionLabel>
                            <GradeGrid>
                                <GradeField>
                                    <GradeLabel>Nota Total</GradeLabel>
                                    <Input
                                        placeholder="Ex.: 10,0"
                                        value={totalGrade}
                                        onChange={(e) => {
                                            let value = e.target.value.replace('.', ',');
                                            value = value.replace(/[^0-9,]/g, '');
                                            if ((value.match(/,/g) || []).length <= 1) {
                                                const numericValue = parseFloat(value.replace(',', '.'));
                                                if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100) {
                                                    setTotalGrade(value);
                                                } else if (value === '') {
                                                    setTotalGrade('');
                                                }
                                            }
                                        }}
                                    />
                                </GradeField>
                                <GradeField>
                                    <GradeLabel>Nota Média</GradeLabel>
                                    <Input
                                        placeholder="Ex.: 6,0"
                                        value={averageGrade}
                                        onChange={(e) => {
                                            let value = e.target.value.replace('.', ',');
                                            value = value.replace(/[^0-9,]/g, '');
                                            if ((value.match(/,/g) || []).length <= 1) {
                                                const numericValue = parseFloat(value.replace(',', '.'));
                                                if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100) {
                                                    setAverageGrade(value);
                                                } else if (value === '') {
                                                    setAverageGrade('');
                                                }
                                            }
                                        }}
                                    />
                                </GradeField>
                            </GradeGrid>
                        </>
                    )}

                    <SectionLabel>Dias letivos</SectionLabel>

                    <CalendarWrap>
                        <SeletorMarcacao modo={markMode} setModo={setMarkMode} descricao={markDesc} setDescricao={setMarkDesc} />
                        <CalendarToolbar>
                            <ToolbarButton type="button" onClick={goPrevMonth} aria-label="Mês anterior">
                                ‹
                            </ToolbarButton>
                            <MonthTitle>
                                {MONTH_NAMES[viewDate.getMonth()]} {viewDate.getFullYear()}
                            </MonthTitle>
                            <ToolbarButton type="button" onClick={goNextMonth} aria-label="Próximo mês">
                                ›
                            </ToolbarButton>
                        </CalendarToolbar>

                        <CalendarGrid>
                            {WEEKDAYS.map(w => (
                                <WeekdayCell key={w}>{w}</WeekdayCell>
                            ))}
                            {calendarCells.map((cell, idx) => {
                                if (!cell) return <EmptyCell key={`e-${idx}`} />;
                                const { day, year, month0, key, isLetivo, weekend, inRange } = cell;
                                // interativo se dentro do período OU já é letivo (p/ poder desmarcar)
                                const mark = nonMap.get(key);
                                const interactive = inRange || isLetivo || !!mark;
                                return (
                                    <DayCell
                                        key={key}
                                        type="button"
                                        $active={isLetivo}
                                        $weekend={weekend}
                                        $disabled={!interactive}
                                        disabled={!interactive}
                                        onClick={() => handleDayClick(year, month0, day)}
                                        aria-pressed={isLetivo}
                                        title={tituloDoDia(key, mark)}
                                        style={mark ? estiloMarcacao(mark.type) : undefined}
                                    >
                                        <DayNumber>{day}</DayNumber>
                                    </DayCell>
                                );
                            })}
                        </CalendarGrid>

                        <LegendRow>
                            <LegendItem>
                                <LegendSwatch $variant="active" /> Dia letivo
                            </LegendItem>
                            <LegendItem>
                                <LegendSwatch $variant="inactive" /> Disponível
                            </LegendItem>
                            <LegendaNaoLetivos Item={LegendItem} Swatch={LegendSwatch} />
                            <LegendItem>
                                <LegendSwatch $variant="disabled" /> Fora do período
                            </LegendItem>
                        </LegendRow>
                    </CalendarWrap>

                    <StatsBar>
                        <StatBlock>
                            <StatValue>{totalLetivos}</StatValue>
                            <StatLabel>Dias letivos selecionados</StatLabel>
                        </StatBlock>
                        <StatBlock>
                            <StatValue style={{ color: TIPOS_DIA.feriado.cor }}>{contagem.feriado}</StatValue>
                            <StatLabel>Feriados</StatLabel>
                        </StatBlock>
                        <StatBlock>
                            <StatValue style={{ color: TIPOS_DIA.recesso.cor }}>{contagem.recesso}</StatValue>
                            <StatLabel>Recessos</StatLabel>
                        </StatBlock>
                        <StatBlock>
                            <StatValue style={{ color: TIPOS_DIA.outro.cor }}>{contagem.outro}</StatValue>
                            <StatLabel>Outros</StatLabel>
                        </StatBlock>
                    </StatsBar>

                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

                    <Btt01 onClick={handleSubmit}>Salvar alterações</Btt01>
                    <ToGoBack onClick={handleGoBack}>
                        <SignMessageButtonText>Voltar ao</SignMessageButtonText>
                        <SignMessageButtonTextBold>Dashboard</SignMessageButtonTextBold>
                    </ToGoBack>
                </Card>
            )}
        </Container>
    );
};

export default EditProfile;